import React, { useEffect, useState, useMemo, useContext } from 'react';
import Language from '../../../common/decorators/Language';
import Single from '../../../layouts/single/Single/Single';
import FAQ from '../../../views/faq/FAQ/FAQ';
import { getData } from '../../../common/utils/router';
import { getDefaultStaticProps, getLangPaths } from '../../api/_props';
import moment from 'moment';
import { transformFaqData } from '../../../views/faq/helpers';
import UserContext from '../../../common/utils/getContext';
const project = require('../../../scripts/configs/project');

const Faq = (props) => {
    const [categories, setCategories] = useState(props?.data);

    useEffect(() => {
        setCategories(props?.data);
    }, [props?.data]);
    const { userToken, lang } = useContext(UserContext);

    const loadMore = useMemo(() => {
        if (categories?.next) {
            return () => {
                getData(categories?.next, userToken, lang).then((newData) => {
                    setCategories((pre) => ({
                        ...pre,
                        categories: [...pre?.categories, ...(newData?.data || [])],
                        next: newData?.links?.next
                    }));
                });
            };
        }
        return null;
    }, [categories, userToken, lang]);

    return (
        <Language translates={props?.translates} page={'/faq'}>
            <Single title='FAQ' translates={props?.translates} alias={'faq'} viewMoveUpBtn>
                <FAQ data={categories} loadMore={loadMore} />
            </Single>
        </Language>
    );
};

export async function getStaticProps({ params }) {
    const defaultProps = await getDefaultStaticProps(params?.lang, '/faq', ['/']);
    if (!defaultProps?.props) {
        return defaultProps;
    }
    const { lang } = defaultProps?.props;
    const categories = await getData(
        '/api/v1/faq/categories?page[size]=25&include=questions',
        false,
        lang,
        moment().format('1DD.ss.2MM.3mm')
    );
    return {
        props: {
            ...defaultProps?.props,
            data: transformFaqData(categories)
        },
        revalidate: project?.revalidate
    };
}
export async function getStaticPaths() {
    const paths = await getLangPaths();
    return {
        paths,
        fallback: true
    };
}

export default Faq;
